import _ from 'lodash';

export const getUniqueNewId = () => {
  return parseInt(_.uniqueId(), 10) * -1;
};
